import {
    FormControl,
    FormLabel,
    Input,
    Select,
    InputProps,
    SelectProps
} from '@chakra-ui/react'
import { ChangeEvent } from 'react'
import { render } from 'redity'
import ErrorHelper from '../../components/ErrorHelper'
import { formPrinterMachine } from './storage'

export default function FormPrinterMachine() {
    return (
        <>
            <Name />
            <TypeConnection />
            <IP />
        </>
    )
}

function Name() {
    const { props, helper, error } =
        formPrinterMachine.useField<InputProps>('name')
    return (
        <FormControl mb={4}>
            <FormLabel>Nombre</FormLabel>
            <Input
                {...props}
                placeholder="Ingresar el nombre de la impresora"
                autoFocus
                maxLength={50}
            />
            <ErrorHelper helper={helper || error} />
        </FormControl>
    )
}

function TypeConnection() {
    const { props, helper, error } =
        formPrinterMachine.useField<SelectProps>('type_printer')

    function changeHandler(ev: ChangeEvent<HTMLSelectElement>) {
        props.onChange(ev)
        render(formPrinterMachine.KeyMain, 'ip')
        render(formPrinterMachine.KeyMain, 'device_name')
    }

    return (
        <FormControl mb={4}>
            <FormLabel>Tipo de conexión</FormLabel>
            <Select
                {...props}
                onChange={changeHandler}
                placeholder="Selecciona tipo de conexión"
            >
                <option value="1">Por IP</option>
                <option value="2">Por USB</option>
            </Select>
            <ErrorHelper helper={helper || error} />
        </FormControl>
    )
}

function IP() {
    const { props, helper } = formPrinterMachine.useField<InputProps>('ip')

    const { type_printer } = formPrinterMachine.store()

    if (type_printer !== '1') {
        return <></>
    }

    return (
        <FormControl marginBottom="4">
            <FormLabel>IP</FormLabel>
            <Input
                {...props}
                placeholder="Ingresa la dirección IP"
                maxLength={15}
            />
            <ErrorHelper helper={helper} />
        </FormControl>
    )
}
